import styled from 'styled-components'

export const DownloadLabel = styled.span`
	display: flex;
	align-items: center;
	column-gap: 4px;
`
